import { render, staticRenderFns } from "./industrialPark.vue?vue&type=template&id=a144a57c&scoped=true&"
import script from "./industrialPark.vue?vue&type=script&lang=js&"
export * from "./industrialPark.vue?vue&type=script&lang=js&"
import style0 from "./industrialPark.vue?vue&type=style&index=0&lang=css&"
import style1 from "./industrialPark.vue?vue&type=style&index=1&id=a144a57c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a144a57c",
  null
  
)

export default component.exports